import {ReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {testingActionsKeys} from '../hooks/useTestingActionsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: testingActionsKeys.all});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
